import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import * as moment from 'moment';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { interval } from 'rxjs';
import { SharedService } from '../../../../../shared-components/shared.service';
import { StudentService } from '../../../../../shared-components/student/student.service';
import { YearService } from '../../../../../shared-components/year/year.service';
import { LoginService } from '../../../../../shared-modules/login/login.service';
import { Card } from '../../../card-container/card/card';
import { StudentSummaryService } from '../../../student-summary.service';
import { CardStudentSchedule } from './card-student-schedule';

@AutoUnsubscribe({
    includeArrays: true
})

@Component({
    selector: 'app-student-schedule-card',
    templateUrl: './student-schedule-card.component.html',
    styleUrls: ['./student-schedule-card.component.css'],
    encapsulation: ViewEncapsulation.None
})

export class StudentScheduleCardComponent implements OnInit, OnDestroy {
    @Input() data: any;
    card: Card;
    schoolToday = true;
    noSchoolMessage = '';
    currentDate = moment();
    nextSchoolDayDate = moment();
    studentSchedule: CardStudentSchedule[] = [];
    tab1Schedule: CardStudentSchedule[] = [];
    tab2Schedule: CardStudentSchedule[] = [];
    scheduleInfoMessage = '';
    DisplayClassMeetsOnStudentScheduleCard: boolean;
    validSchoolNextDay = true;
    calendarUseAttendanceTypes = false;

    constructor(
        private router: Router,
        private loginService: LoginService,
        private studentService: StudentService,
        private sharedService: SharedService,
        private studentSummaryService: StudentSummaryService,
        private yearService: YearService) {
    }

    ngOnInit() {
        this.DisplayClassMeetsOnStudentScheduleCard = this.loginService.LoginSettings.DisplayClassMeetsOnStudentScheduleCard;
        this.card = this.data;
        if (this.card.display != 'Off') {
            const schoolIdStream = interval(100).subscribe(x => {
                if (this.studentService.studentEnrollment !== undefined) {
                    this.getCalendarUseAttendanceTypes();
                    this.getStudentSchedule();
                    schoolIdStream.unsubscribe();
                }
            });
        }
    }

    ngOnDestroy(): void {
    }

    viewTermScheduleClick() {
        const navigationExtras: NavigationExtras = {
            queryParams: {
                selectedView: 1 // 1 = Today's Schedule
            }
        };
        this.router.navigate(['/student360/schedule'], navigationExtras);
    }

    isDisabled() {
        if (this.card.disabled) {
            return 'disabledColor';
        } else {
            return 'enabledColor';
        }
    }

    getCalendarUseAttendanceTypes() {
        this.sharedService.getCalendarUseAttendanceTypes(0, this.yearService.student360Year.Id, this.studentService.selectedStudent.Id).subscribe(result => {
            this.calendarUseAttendanceTypes = result;
        });
    }

    getStudentSchedule() {
        const schoolId = this.studentService.studentEnrollment != null ? this.studentService.studentEnrollment.SchoolId : 0;
        this.studentSummaryService.getCardStudentSchedule(this.studentService.selectedStudent.Id, schoolId, this.yearService.student360Year.AYIdentifier, this.yearService.student360Year.Id).subscribe(response => {
            // console.log(_.cloneDeep(response.body));
            if (response.ok) {
                this.studentSchedule = response.body;
                // Format Dates
                for (let i = 0; i < this.studentSchedule.length; i++) {
                    this.studentSchedule[i].StartTime = moment(this.studentSchedule[i].StartTime, 'HH:mm:ss').format('h:mm');
                    this.studentSchedule[i].EndTime = moment(this.studentSchedule[i].EndTime, 'HH:mm:ss').format('h:mm A');
                    if (this.studentSchedule[i].LunchStartTime != '00:00:00') {
                        this.studentSchedule[i].LunchStartTime = moment(this.studentSchedule[i].LunchStartTime, 'HH:mm:ss').format('h:mm');
                    }
                    if (this.studentSchedule[i].LunchEndTime != '00:00:00') {
                        this.studentSchedule[i].LunchEndTime = moment(this.studentSchedule[i].LunchEndTime, 'HH:mm:ss').format('h:mm A');
                    }
                }
                // Filter out today's classes
                setTimeout(() => {
                    this.tab1Schedule = this.studentSchedule.filter(c => c.MeetsToday == true);
                }, 500);
                // Filter out tomorrows classes
                this.tab2Schedule = this.studentSchedule.filter(c => c.MeetsNextSchoolDay == true);
                if (this.nextSchoolDayDate.isValid() == false) {
                    this.validSchoolNextDay = false;
                }
            }
        });
    }

    showTabs() {
        // If no records are returned - false
        // If studentSchedule length = 1 and studentSchedule[0].CourseName = No school today || No School Next Day - false
        if (this.studentSchedule.length == 0) {
            this.scheduleInfoMessage = marker('No Schedule Information').toString();
            return false;
        } else if (this.studentSchedule.length == 1 && (this.studentSchedule[0].CourseName == 'No School Today' || this.studentSchedule[0].CourseName == 'No Next School Day')) {
            this.scheduleInfoMessage = 'No Schedule Information';
            return false;
        } else if (this.studentSchedule.length == 2 && (this.studentSchedule[0].CourseName == 'No School Today' && this.studentSchedule[1].CourseName == 'No Next School Day')) {
            this.scheduleInfoMessage = 'No Schedule Information';
            return false;
        } else {
            return true;
        }
    }

    tab1Title() {
        if (this.tab1Schedule[0] && (this.tab1Schedule[0].TodayAfterLastDayOfSchool || this.tab2Schedule[0].NoSchoolNextSchoolDate) && this.tab1Schedule[0].MeetsToday) {
            return marker('Last School Day').toString();
        }
        else if (this.tab1Schedule[0] && this.tab1Schedule[0].TodayBeforeFirstDayOfSchool && this.tab1Schedule[0].MeetsToday) {
            return marker('First Day Of School').toString();
        }
        else if (this.tab1Schedule[0] && this.tab2Schedule[0] && this.tab1Schedule[0].MeetsToday && this.tab2Schedule[0].NoSchoolNextSchoolDate) {
            return marker('Last School Day').toString();
        }
        else {
            return marker('Today').toString();
        }
    }

    tab1Date() {
        if (this.tab1Schedule[0]) {
            if ((this.tab1Schedule[0].TodayAfterLastDayOfSchool || this.tab1Schedule[0].TodayBeforeFirstDayOfSchool) && this.tab1Schedule[0].MeetsToday) {
                return moment(this.tab1Schedule[0].TodaysDate, 'MM/DD/YYYY hh:mm:ss A').format('dddd MM/DD');
            }
            else {
                if (!this.tab1Schedule[0].TodayAfterLastDayOfSchool && !this.tab1Schedule[0].TodayBeforeFirstDayOfSchool) {
                    return moment(this.tab1Schedule[0].TodaysDate, 'MM/DD/YYYY hh:mm:ss A').format('dddd MM/DD');
                }
                else {
                    return this.currentDate.format('dddd MM/DD');
                }
            }
        }
        else {
            return this.currentDate.format('dddd MM/DD');
        }
    }

    showTab2Schedule() {
        if (this.tab2Schedule[0] && this.tab2Schedule[0].CourseName == 'No Next School Day' && this.tab2Schedule[0].MeetsNextSchoolDay) {
            return false;
        } else {
            return true;
        }
    }

    tab2Date() {
        if (this.tab2Schedule[0]) {
            if (this.tab2Schedule[0].CourseName == 'No Next School Day' && this.tab2Schedule[0].NoSchoolNextSchoolDate == false) {
                return moment(this.currentDate).add(1, 'day').format('dddd MM/DD');
            }
            else if (this.tab2Schedule[0].CourseName == 'No Next School Day' && this.tab2Schedule[0].TodayAfterLastDayOfSchool) {
                return '';
            }
            else if (this.tab2Schedule[0].CourseName == 'No Next School Day' && this.tab2Schedule[0].NoSchoolNextSchoolDate) {
                return moment(this.tab2Schedule[0].TodaysDate, 'MM/DD/YYYY hh:mm:ss A').format('dddd MM/DD');
            }
            else {
                return moment(this.tab2Schedule[0].NextSchoolDate, 'MM/DD/YYYY hh:mm:ss A').format('dddd MM/DD');
            }
        }
    }

    tab2Title() {
        if (this.tab2Schedule[0] && this.tab2Schedule[0].CourseName == 'No Next School Day' && this.tab2Schedule[0].Withdrawn) {
            return marker('Withdrawn').toString();
        }
        else if (this.tab2Schedule[0] && this.tab2Schedule[0].CourseName == 'No Next School Day' && this.tab2Schedule[0].MeetsNextSchoolDay) {
            return marker('End Of School Year').toString();
        }
        else {
            return marker('Next School Day').toString();
        }
    }
}
